import React, { useState, useEffect } from "react";
import "./user.scss";
import Sidebar from "../Sidebar";
import Header from "../../component/loaderComponent/Header/Header";
import { useDispatch } from "react-redux";
import { UserNameListAction, UserNameAction } from "../../actions/UserAction";
import { RoleNameAction, RoleNameListAction } from "../../actions/RoleAction";
import Loader from "../../component/loaderComponent/loaderComponent/Loader";
import NoDataFound from "../../component/noDataComponent/NoDataFound";
import { Image_Url } from "../../ImageUrl/ImageUrl";
import { useNavigate } from "react-router-dom";
import { encode } from "base-64";
import ConfirmationPopup from "../../component/ConfirmationPopup";
import { HiMenu, HiX } from "react-icons/hi";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import { notify } from '../../services/notification';
import { UpdateUserAction } from "../../actions/UserAction";
import Cookies from 'js-cookie';
import { decode } from "base-64";
import { constant, vehicleType } from "../../constants/constant";
import useMobileView from "../../constants/useMobileView";
import { is2w, is3w } from "../../common/isLogin";

function User() {
  const [isLoading, setLoading] = useState(false);
  const [roleNames, setRoleNames] = useState([]);
  const [userNamesList, setUserNamesList] = useState([]);
  const {  isSidebarOpen, toggleSidebar } = useMobileView();
  const [states, setStates] = useState('');
  const [count, setCount] = useState(1);
  const [page, setPage] = useState(1);
  const [openStatusModal, setOpenStatusModal] = useState(false);
  const [currentStatus, setCurrentStatus] = useState("");
  const [currentStatusId, setCurrentStatusId] = useState("");

  
  var Role = "";
  var RoleData = Cookies.get('role') ? Cookies.get('role') : "";
  if (RoleData) {
    Role = decode(RoleData)
  }

  const dispatch = useDispatch();

  async function GetRoleNameData() {
    setLoading(true);
    var response = await dispatch(RoleNameAction());
    if (response?.status === 200) {
      setLoading(false);
      setRoleNames(response?.data?.results?.data);
    } else if (response === undefined) {
      setLoading(false);
    }
  }

  async function GetUserNameListData(pageNumber) {
    setLoading(true);
    var response = await dispatch(UserNameListAction(pageNumber, constant.paginationCount, states?.role, states?.admin_user_name));
    if (response?.status === 200) {
      setLoading(false);
      setUserNamesList(response?.data?.results?.data);
      setCount(Math.ceil(response.data.count / constant.paginationCount))
      setpaginationListcount(response.data.count);
    }
  }

  const [paginationListcount, setpaginationListcount] = useState(0);
  const startItem = userNamesList?.length === 0 ? 0 : (page - 1) * constant.paginationCount + 1;
  const endItem = Math.min(page * constant.paginationCount, paginationListcount);

  const CreateUser = (evt) => {
    navigate('/createuser')
  }

  const navigate = useNavigate();


  useEffect(() => {
    if (!states?.role) {
      GetRoleNameData()
      GetUserNameListData(1)
    }
  }, [states?.role]);

  useEffect(() => {
    if (states === null) {
      GetUserNameListData(1)
    }
  }, [states]);

  const handleChange = (evt) => {
    const { name, value } = evt.target;
    if (value.length === 0){
      setStates(null);
    }
    else {
    setStates({
      ...states,
      [name]: value.replace(/^ +/gm, ""),
    });
    }
  };

  const UpdateUser = (id) => {
    navigate(`/edituser/${encode(id)}`)
  }
  const handlePageChange = (event, value) => {
    setPage(value);
    GetUserNameListData(value)
  };
  const handleOpenStatusConfirmationModal = (id, status) => {
    setCurrentStatus(status)
    setCurrentStatusId(id)
    setOpenStatusModal(true)
  }

  const handleCloseStatusConfirmationModal = () => {
    setCurrentStatus("")
    setCurrentStatusId("")
    setOpenStatusModal(false)
  }

  const handleOnStatusClick = () => {
    const lowerCaseCurrentStatus = currentStatus?.toLowerCase(); // Convert currentStatus to lowercase
    if (lowerCaseCurrentStatus === "activated") {
      handleOnActiveClick(currentStatusId, "deactivated");
    } else {
      handleOnActiveClick(currentStatusId, "activated");
    }
  };

  const handleOnActiveClick = async (id, data) => {
    const apiReq = {
      status: data
    };
    setLoading(true);
    try {
      const response = await dispatch(UpdateUserAction(apiReq, id));
      if (response?.status === 200) {
        notify.success(response.data.message);
        handleCloseStatusConfirmationModal();
        GetUserNameListData(page);
        setLoading(false);
        window.scroll(0, 0);
      } else if (response?.status === 400) {
        // Handle 400 status error
        // if (response.data && response.data.error) {
        //   notify.error(response.data.error);
        // }
        setLoading(false);
      }
    } catch (error) {
      // Handle other errors
      setLoading(false);
    }
  };

  return (
    <div className="user-management-container">     
      <div className="user-management-right-sidebar">
        <Header title="User Management" />
        {isLoading ? (
          <Loader />
        ) : (
          <div className="user-management-first-collumn">
            <div className="user-managements">
              <div className={` ${(is3w()) ? 'user-management-3w' : 'user-management' }`}>
                <div className="field-col">
                <label className="label-user-management">Role</label>
                <select className="text-filed-dropdown-user-management" name="role" value={states?.role} onChange={handleChange}>
                  <option value="">Select Role</option>
                  {roleNames?.length > 0 && roleNames?.map((data) => (
                    <option key={data.id} value={data?.id}>
                      {data?.role}
                    </option>
                  ))}
                </select>
                </div>
                { (is2w()) && 
                <div className="field-col">
                <label className="label-user-management">User Name</label>
                <input
                      type="search"
                      className="text-filed-dropdown-user-management"
                      placeholder="Enter a Value"
                      name="admin_user_name"
                      value={states?.admin_user_name}
                      onChange={handleChange}
                    />
                </div>
                }
                <button
                  type="button" 
                  className="user-edit-button"
                  onClick={() => GetUserNameListData(1)}
                  disabled={!(states?.role || states?.admin_user_name)}
                >
                  Search
                </button>
              </div>
              <div className="user-button-adds">
                <button
                  type="button"
                  className="create-user-management"
                  onClick={CreateUser}
                >
                  Create User +
                </button>
              </div>
            </div>
            {userNamesList?.length > 0 ?
              <div className="table-data">

                <table className="table">
                  <tr className="tablesth">
                    <th>User Name</th>
                    <th>Login Id</th>
                    <th>Role</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                  {userNamesList.map((data, index) => (
                    <tr className="tabletd query_text">
                      <td>{data?.name}</td>
                      <td className="table-email" title={data?.email}>{data?.email}</td>
                      <td>{data?.role}</td>
                      <td>{data?.status}</td>
                      {data?.role_name?.toLowerCase() === "super_admin" ?
                        <td></td> :
                        <td className="tabletdV">
                          <div className="edit-icons">
                            <img
                              src={Image_Url.EDIT}
                              className="editicons"
                              onClick={() => UpdateUser(data.id)}
                            />
                            {data?.status != "Pending Verification" && Role?.toLowerCase() === 'super_admin' ?
                              <label className="switch">
                                <input
                                  type="checkbox"
                                  checked={data?.status?.toLowerCase() === "activated"} // Convert status to lowercase for comparison
                                  onClick={() => {
                                    handleOpenStatusConfirmationModal(data.id, data.status);
                                  }}
                                />
                                <span className="slider round"></span>
                              </label>
                              : ""}
                          </div>
                        </td>
                      }
                    </tr>
                  ))}
                </table>
              </div>
              : <NoDataFound />}
              <div className="Pagination_section">
                  <Stack spacing={2}>
                    <Pagination
                      count={count}
                      className="pagination"
                      page={page}
                      size="medium"
                      defaultPage={1}
                      color="primary"
                      onChange={handlePageChange}
                    />
                  </Stack>
                  <div className="count">
                    <b>
                      <span>Displaying {startItem} to {endItem} out of {paginationListcount}</span>
                    </b>
                  </div>
                </div>
          </div>
        )}
      </div>
      <ConfirmationPopup
        openDeleteModal={openStatusModal}
        handleOnDeleteClick={handleOnStatusClick}
        handleCloseDeleteConfirmationModal={handleCloseStatusConfirmationModal}
        messageHeading={"WARNING!"}
        messageBody={`Are you sure you want to ${currentStatus?.toLowerCase() === "activated" ? "deactivate" : "activate"} the user?`}
        isLoading={isLoading}
        loadingMessage={"Updating..."}
      />
    </div>
  );
}

export default User;